<template>
  <div class="login-main">
    <img class="logo" src="@/assets/images/login-logo2.png">
    <div class="from-content">
      <LoginForm ref="loginForm"  @showWechatQrCodeMsg="showWechatQrCode" @showRegisterMsg="showRegister" @showSetPasswordMsg="showSetPassword"></LoginForm>
      <RegisterForm ref="registerForm" @showRulesMsg="showRules" @showLoginSuccMsg="showLoginSucc" @showLoginMsg="showLogin"></RegisterForm>
      <ResetPasswordForm ref="resetPasswordForm" @showLoginSuccMsg="showLoginSucc" @showLoginMsg="showLogin"></ResetPasswordForm>
      <UserRules ref="userRules"></UserRules>
      <img src="../../assets/images/earth.gif" alt="gif" class="earth">
      <LoginSucc ref="loginSucc" @showLoginMsg="showLogin"></LoginSucc>
    </div>
     <QrCode v-if="showQrCode" @showBindingAccountMsg="showBinding" @showLoginMsg="showLogin"></QrCode>
     <BindingAccount
      :openId="openId"
      v-if="showBindingAccount"
      @showRulesMsg="showRules"
      @showQrCodeMsg="showWechatQrCode"
    ></BindingAccount>
    <div class="bottom">©2022 shine <a href="https://beian.miit.gov.cn/" style="color: #fff;">蜀ICP备19004958号-4</a>，为了让您获得更好的操作体验，推荐您下载安装并使用Chrome浏览器登录系统。</div>
  </div>
</template>

<script>
import LoginForm from './Components/LoginForm'
import RegisterForm from './Components/RegisterForm'
import ResetPasswordForm from './Components/ResetPasswordForm'
import UserRules from './Components/UserRules'
import LoginSucc from './Components/LoginSucc'

import QrCode from './Components/QrCode.vue'
import BindingAccount from './Components/BindingAccount.vue'

export default {
  name: 'Login',
  components: {
    LoginForm,
    RegisterForm,
    ResetPasswordForm,
    UserRules,
    LoginSucc,
    QrCode,
    BindingAccount
  },
  data () {
    return {
      showQrCode: false,
      showBindingAccount: false,
      openId: ''
    }
  },
  mounted () {
    // this.showLoginSucc()
  },
  created () {

  },
  methods: {
    showRegister () {
      this.showQrCode = false
      this.showBindingAccount = false
      this.$refs.registerForm.show(true)
      this.$refs.resetPasswordForm.show(false)
      this.$refs.loginForm.show(false)
      this.$refs.loginSucc.show(false)
    },
    showLogin () {
      this.showQrCode = false
      this.showBindingAccount = false
      this.$refs.registerForm.show(false)
      this.$refs.resetPasswordForm.show(false)
      this.$refs.loginForm.show(true)
      this.$refs.loginSucc.show(false)
    },
    showSetPassword () {
      this.showQrCode = false
      this.showBindingAccount = false
      this.$refs.registerForm.show(false)
      this.$refs.resetPasswordForm.show(true)
      this.$refs.loginForm.show(false)
      this.$refs.loginSucc.show(false)
    },
    showRules () {
      this.$refs.userRules.show(true)
    },
    showLoginSucc (type) {
      this.showQrCode = false
      this.showBindingAccount = false
      this.$refs.registerForm.show(false)
      this.$refs.resetPasswordForm.show(false)
      this.$refs.loginForm.show(false)
      this.$refs.loginSucc.show(true, type)
    },

    showWechatQrCode () {
      this.showQrCode = true
      this.showBindingAccount = false
      this.$refs.registerForm.show(false)
      this.$refs.resetPasswordForm.show(false)
      this.$refs.loginForm.show(false)
      this.$refs.loginSucc.show(false)
    },
    showBinding (openId) {
      this.openId = openId
      this.showBindingAccount = true
      this.showQrCode = false
      this.$refs.registerForm.show(false)
      this.$refs.resetPasswordForm.show(false)
      this.$refs.loginForm.show(false)
      this.$refs.loginSucc.show(false)
    }
  }
}
</script>

<style lang="scss">
.login-main {
  .el-input .el-input__inner {
    height: 40px;
    border-color: #ddd;
    &:hover {
      border-color: $hover-color !important;
    }
    &:focus {
      border-color: $hover-color !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../commonStyle/variable.scss';
.login-main {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/loginbg.png') no-repeat;
  background-size: cover;
  position: relative;
  .logo{
    position: absolute;
    left: 45px;
    top: 57px;
  }
  .from-content{
    display: flex;
    height: 100%;
    align-items: center;
    float: right;
    margin-right: 120px;
  }
  .earth{
    position: absolute;
    left: 116px;
    top: 129px;
    transform: scale(1.35);
    width: 1000px;
    height: 563px;
    pointer-events: none;
  }
  .bottom{
    position: absolute;
    bottom: 17px;
    width: 100%;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #DFEDF3;
    line-height: 18px;
    opacity: 0.5;
    text-align: center;
  }
}
</style>
